export const JURISDICTION_ABV_COLUMN = "Abv.";
export const STH_TYPE_COLUMN = "STH Type";
export const STATE_DATE_COLUMN = "State Date";
export const END_DATE_COLUMN = "End Date";

export const ATIN_ID_COLUMN = "ATIN ID";
export const ATIN_NAME_COLUMN = "ATIN Name";
export const PTC_NA_COLUMN = "PTC_NA";
export const PTC_ATOM_COUNT = "PTC ATOM Count";
export const PTC_TAXABILITY_PATTERN = "PTC Taxability Pattern";
export const DEPRECATED_COLUMN = "Deprecated";
export const PTC_ACTION_COLUMN = "PTC Action";
export const FINAL_PTC_COLUMN = "Final PTC";

export const PTC_NAME_COLUMN = "PTC";
export const FIRST_JURISDICTION = "AK";
export const LAST_JURISDICTION = "WY";

export const NEW_PTC_NAME = "NEW_PTC";
export const PTC_NAME_SEPARATOR = "_";

export const DEPRECATION_DATE_COLUMN = "DeprecationDate";

export const STH_JURISDICTION_COLUMN_SEPARATOR = "_";
export const BLANK_BASELINE_TAXABILITY = "_";
export const BLANK_STH_TAXABILITY = "_";
export const STH_TAXABILITY_SEPARATOR = "|";

export const DEFAULT_STH_DATES_SHEET_NAME = "STH Dates";
export const DEFAULT_PTC_TAXABILITY_SHEET_NAME = "TDM";
export const DEFAULT_TAXONOMY_EXPORT_SHEET_NAME = "Taxonomy Export";
export const DEFAULT_EXCLUDED_PTCS_SHEET_NAME = "PTCs Excluded";

export const STH_DATES_WORKSHEET_LABEL = `${DEFAULT_STH_DATES_SHEET_NAME} Worksheet`;
export const TAXONOMY_EXPORT_WORKSHEET_LABEL = `${DEFAULT_TAXONOMY_EXPORT_SHEET_NAME} Worksheet`;
export const TDM_WORKSHEET_LABEL = `${DEFAULT_PTC_TAXABILITY_SHEET_NAME} Worksheet`;
export const DATE_RANGE_LABEL = "Date Range";
export const EXCLUDED_PTCS_WORKSHEET_LABEL = `${DEFAULT_EXCLUDED_PTCS_SHEET_NAME} Worksheet`;

export const ANALYSIS_WORKSHEET_LABEL = "Analysis Worksheet";
export const PTC_TO_REPLACE_LABEL = "PTC to Replace";
export const NEW_PTC_LABEL = "PTC to Replace With";

export const ANALYSIS_SHEET_NAME = "Analysis";

export const YES_STRING = "Yes";

export const NONE_THRESHOLD = "None";
export const CT_THRESHOLD = "CT";

export const STH_DATES_REQUIRED_COLUMNS = [
  JURISDICTION_ABV_COLUMN,
  STH_TYPE_COLUMN,
  STATE_DATE_COLUMN,
  END_DATE_COLUMN,
];
export const TAXONOMY_EXPORT_REQUIRED_COLUMNS = [
  ATIN_ID_COLUMN,
  ATIN_NAME_COLUMN,
  DEPRECATION_DATE_COLUMN,
  PTC_NA_COLUMN,
];
export const STH_SHEET_REQUIRED_COLUMNS = [ATIN_ID_COLUMN];
export const TDM_REQUIRED_COLUMNS = [PTC_NAME_COLUMN, FIRST_JURISDICTION, LAST_JURISDICTION];

export const ANALYSIS_SHEET_COLUMNS_BEFORE_STH_JURISDICTIONS = [
  DEPRECATED_COLUMN,
  ATIN_ID_COLUMN,
  ATIN_NAME_COLUMN,
  PTC_NA_COLUMN,
  PTC_ATOM_COUNT,
  PTC_TAXABILITY_PATTERN,
];
export const ANALYSIS_SHEET_COLUMNS_AFTER_STH_JURISDICTIONS = [PTC_ACTION_COLUMN, FINAL_PTC_COLUMN];
export const ANALYSIS_SHEET_REQUIRED_COLUMNS = [
  ...ANALYSIS_SHEET_COLUMNS_BEFORE_STH_JURISDICTIONS,
  ...ANALYSIS_SHEET_COLUMNS_AFTER_STH_JURISDICTIONS,
];

export const STH_DATES_CONSTRAINT_TEXT = `Must contain columns: ${STH_DATES_REQUIRED_COLUMNS.join(
  ", "
)}. Dates must be in Excel Date format.`;
export const TAXONOMY_EXPORT_CONSTRAINT_TEXT = `Must contain columns: ${TAXONOMY_EXPORT_REQUIRED_COLUMNS.join(
  ", "
)}. Dates must be in Excel Date format. Cannot contain PTCs beginning with "${NEW_PTC_NAME}".`;
export const TDM_CONSTRAINT_TEXT = `Must contain column ${PTC_NAME_COLUMN} and jurisdictions from ${FIRST_JURISDICTION} to ${LAST_JURISDICTION}`;
export const ANALYSIS_SHEET_CONSTRAINT_TEXT = `Output worksheet of PTC analysis to replace Final PTC values. Sheet name and columns should not be changed from the generated sheet.`;

export const EXCLUDED_PTCS_DESCRIPTION = "Optional - List of PTCs that should not be used for STH";

export const PTC_REPLACER_INCORRECT_STH_CONFIG_WARNING =
  "WARNING: This PTC is already being used for a different STH taxability pattern";
export const PTC_REPLACER_USED_BY_NON_STH_ATINS_WARNING = (number: number) =>
  `WARNING: This PTC is used by ${number} ATIN(s) not impacted by the STHs in this analysis sheet`;
